export const TENANT = {
    ID: 0,
    TENANT_NAME: ''
}